import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import {
  AccountsReceivableSalesJournalReportFormModel,
  CurrencyApplicationEnum,
  OrderByEnum,
  OrderDirectionEnum,
} from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): AccountsReceivableSalesJournalReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  crs_number: null,
  card_ids: [],
  currency: null,
  currency_application: CurrencyApplicationEnum.INVOICE,
  fixed_at: null,
  invoice_types: [],
  order_by: OrderByEnum.INVOICE_DATE,
  sens: OrderDirectionEnum.DESC,
  file_type: 'pdf',
});
